export function formatCLP(value) {
  if (value === null || value === undefined || value === "") return "—";
  const n = Number(value);
  if (Number.isNaN(n)) return "—";
  return "$" + n.toLocaleString("es-CL", { maximumFractionDigits: 0 });
}

export function formatRUT(rut) {
  if (!rut) return "";
  let clean = rut.toString().toUpperCase().replace(/[^0-9K]/g, "");
  if (clean.length < 2) return clean;
  const body = clean.slice(0, -1);
  const dv = clean.slice(-1);
  const withDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${withDots}-${dv}`;
}

export function pct(value) {
  if (value === null || value === undefined) return "—";
  return `${value}%`;
}
